import { render, staticRenderFns } from "./GoodsReturnCreate.vue?vue&type=template&id=6f0c9e6f"
import script from "./GoodsReturnCreate.vue?vue&type=script&lang=js"
export * from "./GoodsReturnCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports